import script from "./ToolModuleComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolModuleComp.vue?vue&type=script&setup=true&lang=js"

import "./ToolModuleComp.vue?vue&type=style&index=0&id=32acb7e6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32acb7e6"]])

export default __exports__